var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between mb-3",
    class: _vm.$style.leaderboardHeader
  }, [_c('BaseTitle', {
    staticClass: "color-primary-blue mb-0"
  }, [_vm._v("Leaderboards")]), _c('RouterLink', {
    staticClass: "text-decoration-none",
    class: _vm.$style.myRankingsButtonWrapper,
    attrs: {
      "to": {
        name: 'my-rankings'
      }
    }
  }, [_c('BaseButton', {
    class: _vm.$style.myRankingsButton
  }, [_c('MottoIcon', {
    attrs: {
      "icon-color": "white",
      "name": "TrophyFill",
      "skip-filter": true
    }
  }), _c('p', {
    staticClass: "button-text color-white"
  }, [_vm._v("My Rankings")])], 1)], 1)], 1), _c('ScrollerSelector', {
    class: _vm.$style.scrollerPeriodSelector,
    attrs: {
      "items": _vm.getPeriods,
      "start-at-end": true
    },
    on: {
      "updateScrollerItem": _vm.selectPeriod
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var currentScrollerItem = _ref.currentScrollerItem;
        return [_c('h2', {
          class: _vm.$style.currentScrollerItem,
          attrs: {
            "data-current-period": ""
          }
        }, [_vm._v(_vm._s(currentScrollerItem))])];
      }
    }])
  }), _vm.loadingLeaderboard ? _c('LoaderIcon') : _vm._e(), !_vm.loadingLeaderboard ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('BaseSelect', {
    class: _vm.$style.leaderboardCategoriesSelect,
    attrs: {
      "name": "leaderboardCategory",
      "options": _vm.getLeaderboardCategories,
      "data-leaderboard-category-selector": ""
    },
    on: {
      "update": _vm.selectLeaderboardCategory
    },
    model: {
      value: _vm.selectedLeaderboardCategory,
      callback: function callback($$v) {
        _vm.selectedLeaderboardCategory = $$v;
      },
      expression: "selectedLeaderboardCategory"
    }
  }), _c('BaseButton', {
    class: _vm.$style.downloadListButton,
    attrs: {
      "theme": "white"
    },
    on: {
      "click": _vm.downloadList
    }
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Download",
      "icon-color": "gray"
    }
  }), _vm._v(" Download list ")], 1)], 1), _c('div', {
    class: _vm.$style.leaderboardContainer
  }, _vm._l(_vm.getLeaderboardDataByCategory, function (data, index) {
    return _c('LeaderboardPosition', {
      key: index,
      attrs: {
        "leaderboard-data": data,
        "leaderboard-position": data.rank,
        "highlight": data.rank < 4
      }
    });
  }), 1)]) : _vm._e()], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }